import {request} from './client';
import type {
	DiagramAiChatRequest,
	DiagramAiChatResponse,
	DiagramAiSearchRequest,
	DiagramAiSearchResponse,
} from '@/types/api';

export const diagramAiApi = {
	async chat(projectId: number, diagramId: number, body: DiagramAiChatRequest) {
		return request<DiagramAiChatResponse>(
			`/api/projects/${projectId}/diagrams/${diagramId}/ai/chat`,
			{method: 'POST', body}
		);
	},

	async search(projectId: number, diagramId: number, body: DiagramAiSearchRequest) {
		return request<DiagramAiSearchResponse>(
			`/api/projects/${projectId}/diagrams/${diagramId}/ai/search`,
			{method: 'POST', body}
		);
	},
};
